<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-textarea
          label="Notes"
          filled
          v-model="general"
          :success-messages="saved"
          rows="20"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      saved: "",
    }
  },
  computed: {
    general: {
      get() {
        return this.$store.state.note.general;
      },
      set: _.debounce(function(val) {
        this.$store.dispatch('note/setGeneral', val).then(() => {
          this.saved = "Saved!"
          setTimeout(() => { this.saved = "" }, 1000)
        })
      }, 1000)
    },
  }
}
</script>
